import { LockKeyhole, ShieldCheck } from "lucide-react";

const highlights = [
	{
		icon: ShieldCheck,
		title: "Enterprise-grade security",
		description: "SSO and credential access with session protection.",
	},
	{
		icon: LockKeyhole,
		title: "Role-based permissions",
		description: "Every action is scoped to your assigned modules.",
	},
] as const;

export const LoginBrandPanel = () => (
	<aside
		className="relative hidden min-h-full w-[44%] max-w-xl shrink-0 overflow-hidden lg:flex lg:flex-col lg:justify-between"
		aria-hidden
	>
		<div className="absolute inset-0 bg-[linear-gradient(145deg,#1a0a0a_0%,#3d1212_42%,#171717_100%)]" />
		<div
			className="absolute inset-0 opacity-[0.35]"
			style={{
				backgroundImage:
					"radial-gradient(circle at 20% 20%, rgba(163,21,21,0.55) 0%, transparent 45%), radial-gradient(circle at 80% 80%, rgba(255,255,255,0.08) 0%, transparent 40%)",
			}}
		/>
		<div
			className="absolute inset-0 opacity-[0.18]"
			style={{
				backgroundImage:
					"linear-gradient(rgba(255,255,255,0.06) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.06) 1px, transparent 1px)",
				backgroundSize: "32px 32px",
			}}
		/>

		<div className="relative z-10 flex flex-col gap-10 p-10 xl:p-14">
			<div>
				<div className="inline-flex items-center gap-2 rounded-full border border-white/15 bg-white/5 px-3 py-1 text-[11px] font-medium uppercase tracking-[0.2em] text-white/70">
					Kerzner Internal
				</div>
				<h1 className="mt-8 text-4xl font-bold tracking-tight text-white xl:text-[2.75rem] xl:leading-tight">
					Private Homes
				</h1>
				<p className="mt-2 text-sm font-medium uppercase tracking-[0.24em] text-white/55">
					Admin Portal
				</p>
				<p className="mt-8 max-w-sm text-base leading-relaxed text-white/75">
					Secure workspace for managing residences, guest experiences, and
					operational workflows across your portfolio.
				</p>
			</div>

			<ul className="space-y-5">
				{highlights.map(({ icon: Icon, title, description }) => (
					<li key={title} className="flex gap-4">
						<div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl border border-white/10 bg-white/10 text-white">
							<Icon className="h-[18px] w-[18px]" strokeWidth={1.75} />
						</div>
						<div>
							<p className="text-sm font-semibold text-white">{title}</p>
							<p className="mt-0.5 text-sm leading-relaxed text-white/60">
								{description}
							</p>
						</div>
					</li>
				))}
			</ul>
		</div>

		<div className="relative z-10 border-t border-white/10 px-10 py-6 text-xs text-white/40 xl:px-14">
			Authorized personnel only. Activity may be monitored.
		</div>
	</aside>
);
